import { c as _c } from "react/compiler-runtime";
import type { Account, RestoreAccount, SourceAccount } from '@repo/api-gw-sdk';
import { CloudProviders } from '@/data/inventory/data';
import type { MultiSelectConditionComponentProps } from '@/types/advanceFilter';
import { getAccountProvider } from '@/utils/accounts';
import { MultiSelectConditionPanel } from '../conditions/conditionComponents';
import { CircleImage } from '../shared/circleImage';
export const AccountCondition = props => {
  const $ = _c(12);
  const t0 = props.isLoading ?? false;
  let t1;
  if ($[0] !== props.entityName || $[1] !== props.property) {
    t1 = props.entityName || props.property.displayName.toLowerCase();
    $[0] = props.entityName;
    $[1] = props.property;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props.accounts) {
    t2 = props.accounts || [];
    $[3] = props.accounts;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = t2.map(_temp);
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== props || $[8] !== t0 || $[9] !== t1 || $[10] !== t3) {
    t4 = <MultiSelectConditionPanel showAddNewButton={true} showSearchBox={true} isLoading={t0} entityName={t1} shouldShowId={true} options={t3} {...props} />;
    $[7] = props;
    $[8] = t0;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
function _temp(account) {
  const cloudProvider = getAccountProvider(account);
  return {
    id: account.providerAccountId,
    name: account.name,
    Image: CloudProviders[cloudProvider] && <CircleImage alt={CloudProviders[cloudProvider].displayName} src={CloudProviders[cloudProvider].logo} className="my-[16px]" />
  };
}